import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { individualRestrictionGuard } from '../../guards/individual-restriction.guard';

export const admin: Routes = [
  {
    path: '',
    children: [
      {
        path: 'support',
        loadComponent: () => import('./support.component').then((m) => m.SupportComponent),
        canActivate: [individualRestrictionGuard],
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class supportRoutingModule {
  static routes = admin;
}
